import type { MonoTypeOperatorFunction } from 'rxjs';

// no-op
export function noop<T>(): MonoTypeOperatorFunction<T> {
    return (source) => source;
}
